/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Station_DetachInputs */

const vi_camera_station_detach = /** @type {(inputs: Camera_Station_DetachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gỡ khỏi trạm`)
};

/**

* @param {Camera_Station_DetachInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_station_detach = /** @type {((inputs?: Camera_Station_DetachInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Station_DetachInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_station_detach(inputs)
});